// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "wangeditor-f18ed9a8" + "." + "43217314" + ".chunk.css";
};